import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "panel-pad mb-4 flex flex-col gap-3 md:flex-row" }
const _hoisted_3 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_4 = { class: "data-table user-table" }
const _hoisted_5 = { class: "divide-y divide-slate-100" }
const _hoisted_6 = { class: "font-semibold text-ink" }
const _hoisted_7 = { class: "status-pill bg-brand-50 text-brand-700" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Tài khoản",
      title: "Danh sách tài khoản",
      description: "Quản lý người dùng, quyền và trạng thái tài khoản."
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_UiButton, {
          to: "/registerpage",
          variant: "white",
          icon: "userAdd"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Tạo tài khoản", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UiInput, {
        modelValue: $setup.query,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.query) = $event)),
        class: "md:w-[30%]",
        placeholder: "Tìm theo tên, username, khoa/phòng..."
      }, null, 8, ["modelValue"]),
      _createVNode(_component_UiButton, {
        variant: "secondary",
        icon: "refresh",
        disabled: $setup.loading,
        onClick: $setup.loadUsers
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Làm mới", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-wrap user-table-wrap", { 'is-loading': $setup.loading }])
    }, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "table-spinner" }, null, -1),
            _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Tên tài khoản"),
            _createElementVNode("th", null, "Họ tên"),
            _createElementVNode("th", null, "Quyền hạn"),
            _createElementVNode("th", null, "Khoa/phòng"),
            _createElementVNode("th", null, "Số điện thoại"),
            _createElementVNode("th", null, "Trạng thái"),
            _createElementVNode("th", null, "Thao tác")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedUsers, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: user.id,
              class: "hover:bg-slate-50"
            }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(user.username), 1),
              _createElementVNode("td", null, _toDisplayString(user.fullname), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(user.permission), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString($setup.getUserDepartmentName(user)), 1),
              _createElementVNode("td", null, _toDisplayString(user.phoneNumber || "-"), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass([
                  'status-pill',
                  user.active === false
                    ? 'bg-rose-50 text-rose-700'
                    : 'bg-emerald-50 text-emerald-700',
                ])
                }, _toDisplayString(user.active === false ? "Khóa" : "Hoạt động"), 3)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_UiButton, {
                  variant: "secondary",
                  size: "sm",
                  icon: "edit",
                  to: `/userupdate/${user.id}`
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Sửa", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          }), 128)),
          (!$setup.filteredUsers.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("td", {
                  colspan: "7",
                  class: "py-10 text-center text-slate-500"
                }, " Không có tài khoản phù hợp. ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createVNode(_component_UiPagination, {
      modelValue: $setup.page,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.page) = $event)),
      total: $setup.filteredUsers.length,
      "page-size": $setup.pageSize
    }, null, 8, ["modelValue", "total", "page-size"])
  ]))
}